import DistTree from './src/disttree.vue';

DistTree.install = function (Vue) {
    Vue.component(DistTree.name, DistTree);
};

export default DistTree;